import axios from 'axios';

class httpService {
  constructor(options) {
    const { subscriptionTokenEnabled } = options;

    this.subscriptionToken = null;

    this.init(subscriptionTokenEnabled);
  }

  init(subscriptionTokenEnabled) {
    this.setDefaultAxios();

    if (subscriptionTokenEnabled) {
      this.watchForSubscriptionToken();
    }
  }

  setDefaultAxios() {
    axios.defaults.baseURL = `${process.env.REACT_APP_API_BASE_URL}/${process.env.REACT_APP_API_VERSION}`;
    axios.defaults.headers = {
      'Content-Type': 'application/json',
    };
  }

  watchForSubscriptionToken() {
    axios.interceptors.response.use(
      (response) => {
        if (response.headers.subscription) {
          console.log('HTTP WATCH TOKEN', response.headers.subscription);

          this.subscriptionToken = response.headers.subscription;
        }

        return response;
      },
      (error) => {
        return Promise.reject(error.message);
      },
    );
  }

  setupInterceptors(token_type = null, access_token = null) {
    axios.interceptors.request.use(
      (config) => {
        const oidcStorage = JSON.parse(sessionStorage.getItem(`oidc.user:${process.env.REACT_APP_AUTH_URL}:${process.env.REACT_APP_AUTH_CLIENT_ID}`));

        if (config.headers) {
          config.headers['Authorization'] = `${oidcStorage?.token_type || token_type} ${oidcStorage?.access_token || access_token}`;

          if (this.subscriptionToken) {
            config.headers['Subscription'] = `Bearer ${this.subscriptionToken}`;
          }
        }

        return config;
      },
      (error) => {
        return Promise.reject(error.message);
      },
    );
  }

  getSubscriptionToken(subscriptionToken) {
    return this.subscriptionToken;
  }

  setSubscriptionToken(subscriptionToken) {
    this.subscriptionToken = subscriptionToken;
  }
}

export default httpService;
